function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/**
 * Structural representation of a lock layer.
 */

/**
 * A callback meant to be invoked whenever the state of a lock stack changes.
 * The first argument, `enabled`, indicates the enabled state of the top lock
 * in the stack, and the second argument, `stack`, is a reference to that
 * stack itself.
 */

/**
 * Simple stack-like structure representing a layer system for focus locks.
 *
 * The stack takes care of enabling and disabling layers as necessary when locks
 * are added or removed from the stack. In this way, it is guaranteed that only
 * the top lock in the stack will be enabled at any given time.
 *
 * The stack also provides a subscription interface for consumers to be notified
 * whenever the state of the stack changes.
 */
var LockStack = /*#__PURE__*/function () {
  function LockStack() {
    _classCallCheck(this, LockStack);

    _defineProperty(this, "locks", []);

    _defineProperty(this, "listeners", []);
  }

  _createClass(LockStack, [{
    key: "add",
    value:
    /**
     * Push a new lock layer onto the top of the stack. This will cause the layer
     * below to be disabled before this lock's callback is enabled.
     * Locks should not enable themselves until the callback has been invoked to
     * ensure that other locks are not also concurrently active.
     */
    function add(uid, setEnabled) {
      var newLock = {
        uid: uid,
        setEnabled: setEnabled,
        enabled: false
      };
      this.toggleLayer(this.current(), false);
      this.locks.push(newLock);
      this.toggleLayer(newLock, true);
      this.emit();
    }
    /**
     * Immediately remove the lock with the given id from the stack. This will
     * call the lock's callback to disable it before removing. Then if it was the
     * currently-active lock, the new current lock will be re-enabled.
     */

  }, {
    key: "remove",
    value: function remove(uid) {
      var lock = this.locks.find(function (lock) {
        return lock.uid === uid;
      });
      this.toggleLayer(lock, false);
      var current = this.current();
      var wasCurrent = current != null && current.uid === uid;
      this.locks = this.locks.filter(function (lock) {
        return lock.uid !== uid;
      });
      if (wasCurrent) this.toggleLayer(this.current(), true);
      this.emit();
    }
    /**
     * Returns the lock that currently lives at the top of the stack.
     */

  }, {
    key: "current",
    value: function current() {
      return this.locks[this.locks.length - 1];
    }
    /**
     * Returns the enabled state of the currently-active lock.
     */

  }, {
    key: "isActive",
    value: function isActive() {
      var current = this.current();
      return current != null ? current.enabled : false;
    }
    /**
     * Utility for enabling and disabling layers atomically.
     */

  }, {
    key: "toggleLayer",
    value: function toggleLayer(lock, enabled) {
      if (lock == null) return;
      lock.setEnabled(enabled);
      lock.enabled = enabled;
    }
    /**
     * Adds a listener that will be invoked whenever the state of the lock stack
     * changes. Callbacks are called with the "enabled" state of the current lock,
     * and the stack itself as a reference.
     *
     * Returns a function to unsubscribe the listener from the stack.
     */

  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this = this;

      this.listeners.push(callback);
      callback(this.isActive(), this.locks);
      return function () {
        return _this.listeners = _this.listeners.filter(function (listener) {
          return listener !== callback;
        });
      };
    }
    /**
     * Updates all currently-subscribed listeners with the current state of the
     * lock stack.
     */

  }, {
    key: "emit",
    value: function emit() {
      var _this2 = this;

      var active = this.isActive();
      this.listeners.forEach(function (listener) {
        return listener(active, _this2.locks);
      });
    }
  }]);

  return LockStack;
}();

export { LockStack as default };
